import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Download, FileText, Fuel, Shield, Users, Gauge, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Brochure data with official Perodua links
const brochureData = [
  {
    id: 'traz',
    name: 'Perodua Traz',
    year: '2026',
    tagline: 'Trendy • Reliable • Adaptive • Zealous',
    image: '/models/traz_nobg.png',
    brochureUrl: 'https://www.perodua.com.my/files/Traz_Brochure.pdf?v=1765937418',
    category: 'SUV',
    isNew: true,
    highlights: [
      { icon: 'engine', label: '1.5L DOHC', detail: '78kW / 138Nm' },
      { icon: 'fuel', label: '21.3 km/l', detail: 'Fuel Economy' },
      { icon: 'safety', label: '5-Star', detail: 'ASEAN NCAP' },
      { icon: 'seats', label: '5-Seater', detail: 'SUV' }
    ],
    variants: ['X', 'H'],
    priceFrom: 'RM78,940'
  },
  {
    id: 'axia',
    name: 'Perodua Axia',
    year: '2026',
    tagline: 'Pretty. Smart.',
    image: 'https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/axia.webp',
    brochureUrl: 'https://www.perodua.com.my/files/Axia_Brochure.pdf?v=1749797573',
    category: 'Hatchback',
    isNew: false,
    highlights: [
      { icon: 'engine', label: '1.0L VVT-i', detail: '50kW / 91Nm' },
      { icon: 'fuel', label: '27.4 km/l', detail: 'ECO Idle' },
      { icon: 'safety', label: 'A.S.A. 2.0', detail: 'Safety Assist' },
      { icon: 'seats', label: '5-Seater', detail: 'Compact' }
    ],
    variants: ['G', 'X', 'SE', 'AV'],
    priceFrom: 'RM40,310'
  },
  {
    id: 'bezza',
    name: 'Perodua Bezza',
    year: '2026',
    tagline: 'Beyond Compact',
    image: 'https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/bezza.webp',
    brochureUrl: 'https://www.perodua.com.my/files/Bezza_Brochure.pdf?v=1724919068',
    category: 'Sedan',
    isNew: false,
    highlights: [
      { icon: 'engine', label: '1.0L / 1.3L', detail: 'Dual VVT-i' },
      { icon: 'fuel', label: '22.8 km/l', detail: 'Fuel Economy' },
      { icon: 'safety', label: '5-Star', detail: 'ASEAN NCAP' },
      { icon: 'seats', label: '508L', detail: 'Boot Space' }
    ],
    variants: ['G', 'X', 'AV'],
    priceFrom: 'RM36,180'
  },
  {
    id: 'myvi',
    name: 'Perodua Myvi',
    year: '2026',
    tagline: 'The Next Standard',
    image: 'https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/myvi.webp',
    brochureUrl: 'https://www.perodua.com.my/files/Myvi_Brochure.pdf?v=1758163069',
    category: 'Hatchback',
    isNew: false,
    highlights: [
      { icon: 'engine', label: '1.3L / 1.5L', detail: 'D-CVT' },
      { icon: 'fuel', label: '22.2 km/l', detail: 'ECO Idle' },
      { icon: 'safety', label: '5-Star', detail: 'ASEAN NCAP' },
      { icon: 'seats', label: '6 Airbags', detail: 'AV Variant' }
    ],
    variants: ['G', 'X', 'H', 'AV'],
    priceFrom: 'RM50,490'
  },
  {
    id: 'ativa',
    name: 'Perodua Ativa',
    year: '2026',
    tagline: 'Adventure Awaits',
    image: 'https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/ativa.webp',
    brochureUrl: 'https://www.perodua.com.my/files/Ativa_Brochure.pdf?v=1764216623',
    category: 'SUV',
    isNew: false,
    highlights: [
      { icon: 'engine', label: '1.0L Turbo', detail: '72kW / 140Nm' },
      { icon: 'fuel', label: '18.9 km/l', detail: 'ECO Idle' },
      { icon: 'safety', label: '5-Star', detail: 'ASEAN NCAP' },
      { icon: 'seats', label: '200mm', detail: 'Ground Clearance' }
    ],
    variants: ['X', 'H', 'AV'],
    priceFrom: 'RM64,880'
  },
  {
    id: 'alza',
    name: 'Perodua Alza',
    year: '2026',
    tagline: 'Versatility Reinvented',
    image: 'https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/alza.webp',
    brochureUrl: 'https://www.perodua.com.my/files/Alza_Brochure.pdf?v=1724919067',
    category: 'MPV',
    isNew: false,
    highlights: [
      { icon: 'engine', label: '1.5L DOHC', detail: '78kW / 138Nm' },
      { icon: 'fuel', label: '22.0 km/l', detail: 'ECO Idle' },
      { icon: 'safety', label: '5-Star', detail: 'ASEAN NCAP' },
      { icon: 'seats', label: '7-Seater', detail: 'Family MPV' }
    ],
    variants: ['X', 'H', 'AV'],
    priceFrom: 'RM68,580'
  },
  {
    id: 'aruz',
    name: 'Perodua Aruz',
    year: '2026',
    tagline: 'Room For Everything',
    image: 'https://www.perodua.com.my/includes/imageresize.php?width=300&quality=75&image=/assets/images/landing-page/cars/with-emblem/aruz.webp',
    brochureUrl: 'https://www.perodua.com.my/files/UpdatedAruz_Brochure.pdf?v=1756463190',
    category: 'SUV',
    isNew: false,
    highlights: [
      { icon: 'engine', label: '1.5L DOHC', detail: '75kW / 133Nm' },
      { icon: 'fuel', label: '15.6 km/l', detail: 'ECO Idle' },
      { icon: 'safety', label: '5-Star', detail: 'ASEAN NCAP' },
      { icon: 'seats', label: '7-Seater', detail: '220mm Ground' }
    ],
    variants: ['X', 'AV'],
    priceFrom: 'RM72,900'
  }
];

const HighlightIcon = ({ type }) => {
  switch (type) {
    case 'engine':
      return <Gauge className="w-5 h-5" />;
    case 'fuel':
      return <Fuel className="w-5 h-5" />;
    case 'safety':
      return <Shield className="w-5 h-5" />;
    case 'seats':
      return <Users className="w-5 h-5" />;
    default:
      return <FileText className="w-5 h-5" />;
  }
};

const BrochureCard = ({ brochure }) => {
  return (
    <Card className="group overflow-hidden hover:shadow-xl transition-all duration-300 border-0 bg-white">
      <CardContent className="p-0">
        {/* Image Section */}
        <div className="relative bg-gradient-to-br from-slate-100 to-slate-200 p-6 h-48 flex items-center justify-center">
          {brochure.isNew && (
            <div className="absolute top-3 left-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse">
              NEW MODEL
            </div>
          )}
          <div className="absolute top-3 right-3 bg-white/90 backdrop-blur px-2 py-1 rounded-lg text-xs font-semibold text-slate-700">
            {brochure.category}
          </div>
          <img
            src={brochure.image}
            alt={brochure.name}
            className="max-h-36 w-auto object-contain group-hover:scale-110 transition-transform duration-300"
          />
        </div>

        {/* Content Section */}
        <div className="p-5">
          {/* Title */}
          <div className="mb-3">
            <h3 className="text-xl font-bold text-slate-900">
              {brochure.name} {brochure.year}
            </h3>
            <p className="text-sm text-slate-500">{brochure.tagline}</p>
          </div>

          {/* Highlights Grid */}
          <div className="grid grid-cols-2 gap-2 mb-4">
            {brochure.highlights.map((highlight, idx) => (
              <div
                key={idx}
                className="flex items-center space-x-2 bg-slate-50 rounded-lg p-2"
              >
                <div className="text-blue-600">
                  <HighlightIcon type={highlight.icon} />
                </div>
                <div>
                  <div className="text-xs font-semibold text-slate-800">{highlight.label}</div>
                  <div className="text-xs text-slate-500">{highlight.detail}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Variants */}
          <div className="flex flex-wrap gap-1 mb-4">
            {brochure.variants.map((variant, idx) => (
              <span
                key={idx}
                className="bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-full font-medium"
              >
                {variant}
              </span>
            ))}
          </div>

          {/* Price & Download */}
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-500">Bermula dari</p>
              <p className="text-lg font-bold text-blue-600">{brochure.priceFrom}</p>
            </div>
            <a
              href={brochure.brochureUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`brochure-download-${brochure.id}`}
              className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold px-4 py-2 rounded-xl transition-all duration-300"
            >
              <Download className="w-4 h-4" />
              <span>Brochure</span>
            </a>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const BrochureCenter = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-slate-600 hover:text-blue-600 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="font-medium">Kembali ke Utama</span>
            </button>
            <div className="flex items-center space-x-2">
              <img
                src="https://www.perodua.com.my/assets/images/logo.png"
                alt="Perodua"
                className="h-8"
              />
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-12 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <FileText className="w-4 h-4" />
            <span>Download Center</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Pusat Muat Turun <span className="text-blue-600">Brochure</span>
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Muat turun brochure rasmi Perodua untuk maklumat lengkap spesifikasi, 
            harga, dan ciri-ciri setiap model.
          </p>
        </div>
      </section>

      {/* Brochures Grid */}
      <section className="pb-16 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Category Filter Badges */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            <span className="bg-white shadow-sm px-4 py-2 rounded-full text-sm font-medium text-slate-700 border border-slate-200">
              📁 7 Model Tersedia
            </span>
            <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium">
              ✅ Brochure Rasmi
            </span>
            <span className="bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
              📄 Format PDF
            </span>
          </div>

          {/* Cards Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {brochureData.map((brochure) => (
              <BrochureCard key={brochure.id} brochure={brochure} />
            ))}
          </div>

          {/* Info Banner */}
          <div className="mt-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-6 md:p-8 text-white">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h3 className="text-2xl font-bold mb-2">Perlukan Bantuan?</h3>
                <p className="text-blue-100">
                  Hubungi saya untuk maklumat lanjut tentang mana-mana model Perodua.
                </p>
              </div>
              <Button
                onClick={() => window.open('https://wa.me/60125006170?text=' + encodeURIComponent('[Website Brochure] Hi Syasyah, saya nak tanya tentang model Perodua.'), '_blank')}
                className="bg-white text-blue-600 hover:bg-blue-50 font-bold px-8 py-4 rounded-xl text-base transition-all duration-300 whitespace-nowrap"
              >
                💬 WhatsApp Syasyah
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-slate-200 py-6">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-slate-500 text-sm">
            Brochure adalah hakcipta Perodua Sales Sdn Bhd. Harga dan spesifikasi tertakluk kepada perubahan.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default BrochureCenter;
